// import { get } from "lodash";
const setCreditCards = (state, payload) => {
  state.creditCards = payload;
};

export default {
  setCreditCards,
};
